import type { ModeloDefaultProps } from "../../banner-fixo.props"
import ConteudoBanner from "../conteudoBanner/ConteudoBanner"

export default function Modelo10({ data }: Readonly<ModeloDefaultProps>) {

    const banners = data.banners.slice(0, 5)
    const device = data.device

    return (
        <div className="fixed-banners fixed-banners-tipo10 container">
            <div className="item-banner flex center justify-center">

                {banners[0] && (
                    <div className="banner-size">
                        <ConteudoBanner data={{
                            banner: banners[0],
                            device
                        }} />
                    </div>
                )}

                <div className="banner-column flex column">
                    <div className="banner-row flex center">
                        {banners.slice(1, 3).map(currentBanner => (
                            <ConteudoBanner key={currentBanner.id} data={{
                                banner: currentBanner,
                                device: data.device
                            }} />
                        ))}
                    </div>
                    <div className="banner-row flex center">
                        {banners.slice(3, 5).map(currentBanner => (
                            <ConteudoBanner key={currentBanner.id} data={{
                                banner: currentBanner,
                                device: data.device
                            }} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}